import { AppAction, AppSel, AppType } from "@/features/applications";
import { firebaseDb } from "@/infrastructure/firebase";
import { useDispatch, useSelector } from "react-redux";

export const useAlertUpdate = () => {
  const dispatch = useDispatch();
  const userDocName = useSelector(AppSel.userDocName);

  return {
    userAlertLimit: useSelector(AppSel.userAlertLimit),
    updateAlertLimit: (newLimit: AppType.AlertLimits[]) => {
      dispatch(AppAction.updateUserInfo({ priceAlert: newLimit }));

      firebaseDb
        .collection("users")
        .doc(userDocName)
        .update({ priceAlert: newLimit });
    }
  };
};
